import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { DEFAULT_LEVEL_LABELS } from "../lib/skills";

// Fonctions métier, compétences et niveaux : trois référentiels chargés ensemble, partagés par l'organisation, le formulaire et la fiche.
export default function useSkillsReferentials() {
  const [data, setData] = useState({ skills: [], functions: [], levels: [], roles: [] });
  const [status, setStatus] = useState("loading"); // loading | ready | error

  const reload = useCallback(async () => {
    try {
      const [skills, functions, levels] = await Promise.all([api.get("/skills"), api.get("/job-functions"), api.get("/skill-levels")]);
      setData({ skills: skills.data.items, functions: functions.data.items, levels: levels.data.items, roles: functions.data.roles || [] });
      setStatus("ready");
    } catch (e) {
      setStatus("error");
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const levelLabel = (code) => data.levels.find((l) => l.code === code)?.label || DEFAULT_LEVEL_LABELS[code] || code;
  const skillLabel = (id) => data.skills.find((s) => s.id === id)?.label || "Compétence";
  const functionLabel = (id) => {
    const fn = data.functions.find((f) => f.id === id);
    return fn ? fn.label + (fn.active ? "" : " (inactive)") : "Fonction";
  };

  return { ...data, status, reload, levelLabel, skillLabel, functionLabel };
}
